import React from 'react';
import './styles/mainButton.css';

const MainButton = ({ children, onClick, href, type = 'button' }) => {
  if (href) {
    return (
      <a href={href} className="pp-main-button pp-main-button--link">
        {children}
      </a>
    );
  }

  return (
    <button 
      type={type} 
      className="pp-main-button pp-main-button--button"
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default MainButton;
